import React from 'react';
import { IconBarChart3, IconDownload, IconRefreshCw } from 'src/icons';
import { TimeRangePicker } from './TimeRangePicker';
import type { TimeRange } from './types';

interface DashboardHeaderProps {
  timeRange: TimeRange;
  customFrom: string;
  customTo: string;
  customOpen: boolean;
  onPresetRange: (range: TimeRange) => void;
  onCustomFromChange: (v: string) => void;
  onCustomToChange: (v: string) => void;
  onCustomOpenChange: (open: boolean) => void;
  onApplyCustom: () => void;
  onExport: () => void;
  onRefresh: () => void;
  refreshing: boolean;
}

export function DashboardHeader({
  timeRange,
  customFrom,
  customTo,
  customOpen,
  onPresetRange,
  onCustomFromChange,
  onCustomToChange,
  onCustomOpenChange,
  onApplyCustom,
  onExport,
  onRefresh,
  refreshing,
}: DashboardHeaderProps) {
  return (
    <div className="top-0 z-10 sticky bg-white/90 backdrop-blur-sm px-1.5 py-1 border-gray-200 border-b shrink-0">
      <div className="flex flex-wrap justify-between items-center gap-1 min-w-0">
        <div className="flex items-center gap-1.5 min-w-0 shrink-0">
          <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-1 rounded shrink-0">
            <IconBarChart3 className="w-3.5 h-3.5 text-white" />
          </div>
          <h1 className="font-semibold text-gray-900 text-xs truncate">Analytics</h1>
        </div>

        <div className="flex flex-wrap items-center gap-1 min-w-0">
          <TimeRangePicker
            timeRange={timeRange}
            customFrom={customFrom}
            customTo={customTo}
            customOpen={customOpen}
            onPresetSelect={onPresetRange}
            onCustomFromChange={onCustomFromChange}
            onCustomToChange={onCustomToChange}
            onCustomOpenChange={onCustomOpenChange}
            onApplyCustom={onApplyCustom}
          />
          {timeRange.value === 'custom' && (customFrom || customTo) && (
            <span className="max-w-[80px] text-[10px] text-gray-500 truncate shrink-0">
              {customFrom}–{customTo}
            </span>
          )}
          <button
            type="button"
            onClick={onExport}
            className="flex items-center gap-0.5 bg-white hover:bg-gray-50 px-1.5 py-0.5 border border-gray-300 rounded text-[10px] shrink-0"
          >
            <IconDownload className="w-3 h-3" />
            Export
          </button>
          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="flex items-center gap-0.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 px-1.5 py-0.5 rounded text-[10px] text-white disabled:cursor-not-allowed shrink-0"
          >
            <IconRefreshCw className={`w-3 h-3 ${refreshing ? 'animate-spin' : ''}`} />
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
}
